import { ref } from 'vue';

export function useStorage() {

  const getTheme = () => {
    return localStorage.getItem('theme') || 'dark';
  }

  const getUserInfo = () => {
    const data = localStorage.getItem('userInfos');
    if (!data) return null;
    try {
      return JSON.parse(data);
    } catch (e) {
      console.error('Error parsing user info:', e);
      return null;
    }
  };

  const userInfo = ref(getUserInfo());

  const clearUserData = () => {
    localStorage.clear();
    userInfo.value = null;
  }

  const isLoggedIn = () => {
    return !!getUserInfo();
  }

  return {
    getTheme,
    getUserInfo,
    isLoggedIn,
    clearUserData,
    userInfo,
  };
} 